import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import 'tslib';
import { ComponentsModule } from '../components/components.module';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UsuarioInativoComponent } from './usuario-inativo/usuario-inativo.component';
import { UsuarioSemModulosComponent } from './usuario-sem-modulos/usuario-sem-modulos.component';

@NgModule({
  declarations: [
    LoginComponent,
    ResetPasswordComponent,
    UsuarioInativoComponent,
    UsuarioSemModulosComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthenticationRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatDialogModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ComponentsModule
  ],
  providers: [
    provideNgxMask()
  ]
})
export class AuthenticationModule { }
